import type { IPilotage } from "./types";
import { MAX_LIVES } from "./data";
import { landscape } from "./terrain";
import { copter } from "./copter";
import { dt } from "lib/loop";

export class AutoPilot implements IPilotage {
  readonly maxLifes = MAX_LIVES;
  private _controlUp = false;
  private _controlDown = false;
  private _toggleTimeout = 0;

  get controlUp(): boolean {
    return this._controlUp;
  }

  get controlDown(): boolean {
    return this._controlDown;
  }

  update(pos: { x: number; y: number }): void {
    const safe = landscape.getSafeRect(pos.x, landscape.vx * 1.67);
    this.safeAreaMethod(pos, safe);
    this._toggleTimeout += dt;
  }

  private safeAreaMethod(pos: { x: number; y: number }, safe: { top: number; bottom: number }): void {
    const maskHeight = 6;
    const predTime = 5 / 30;
    const predOffsetY = copter.vy * predTime;

    if (pos.y - maskHeight + predOffsetY < safe.top) {
      this.setControl(-1);
      return;
    }
    if (pos.y + maskHeight + predOffsetY > safe.bottom) {
      this.setControl(1);
      return;
    }

    this.predMethod(pos);
  }

  private predMethod(pos: { x: number; y: number }): void {
    const { top, bottom } = landscape.getPlaceOffsets(pos.x);
    const dt = pos.y - top;
    const db = bottom - pos.y;

    if (dt <= db) {
      this.suggestControl(-1);
    } else {
      this.suggestControl(1);
    }
  }

  private suggestControl(dir: number): void {
    if ((dir > 0 && !this._controlUp) || (dir < 0 && !this._controlDown)) {
      if (this._toggleTimeout < 0.67) return;
    }
    this.setControl(dir);
  }

  private setControl(dir: number): void {
    if (dir > 0) {
      this._controlUp = true;
      this._controlDown = false;
    } else {
      this._controlUp = false;
      this._controlDown = true;
    }
    this._toggleTimeout = 0;
  }
}
